module.exports = __webpack_public_path__ + "static/media/final2.01a333ea.jpg";